var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import InputField from "@frameworks/web/components/generic/inputField";
import SelectDropdown from "@frameworks/shared-library/components/selectdropdown";
import loaderGIF from "@frameworks/shared-library/assets/images/Reports/loaderGIF.gif";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import Inputtablebottom from "@frameworks/salesjourney/components/Generic/Inputtablebottom";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import AddFamilyOtp from "./AddFamilyOtp";
import { ErrorText } from "../constents";
var AddFamilyMember = function (props) {
    var _a, _b, _c, _d;
    var _e = __read(React.useState([]), 2), searchData = _e[0], setSearchData = _e[1];
    var _f = __read(React.useState(false), 2), resendOtp = _f[0], setResentOtp = _f[1];
    var _g = __read(useState(false), 2), mobileOtpSentSuccess = _g[0], setMobileOtpSentSuccess = _g[1];
    var _h = __read(useState(false), 2), emailOtpSentSuccess = _h[0], setEmailOtpSentSuccess = _h[1];
    var _j = __read(React.useState(null), 2), selectedFamliyTaggingEntity = _j[0], setSelectedFamliyTaggingEntity = _j[1];
    var _k = __read(React.useState(false), 2), searchLoader = _k[0], setSearchLoader = _k[1];
    var _l = __read(React.useState(false), 2), showMobileOtp = _l[0], setShowMobileOtp = _l[1];
    var _m = __read(React.useState(true), 2), showMobileOtpSection = _m[0], setShowMobileOtpSection = _m[1];
    var _o = __read(React.useState(true), 2), showEmailOtpSection = _o[0], setShowEmailOtpSection = _o[1];
    var _p = __read(React.useState(false), 2), showEmailOtp = _p[0], setShowEmailOtp = _p[1];
    var _q = __read(React.useState(false), 2), verifiedMobileOtp = _q[0], setVerifiedMobileOtp = _q[1];
    var _r = __read(React.useState(false), 2), verifiedEmailOtp = _r[0], setVerifiedEmailOtp = _r[1];
    var _s = __read(React.useState(false), 2), verifiedOtpLoader = _s[0], setVerifiedOtpLoader = _s[1];
    var _t = __read(React.useState(false), 2), verifiedEmailOtpLoader = _t[0], setVerifiedEmailOtpLoader = _t[1];
    var _u = __read(React.useState(false), 2), openState = _u[0], setOpenState = _u[1];
    var _v = __read(React.useState({
        relation: null,
        accode: "",
        otp: "",
        otponsms: "1",
        otponemail: "",
    }), 2), addFamilyMember = _v[0], SetAddFamilyMemeber = _v[1];
    var _w = __read(React.useState({
        relation: "",
        accode: "",
        otp: "",
        emailOtp: "",
        isMobile: null,
        isEmail: null,
    }), 2), error = _w[0], setError = _w[1];
    var verifyOtp = function (otp, isMobile) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isMobile) {
                setVerifiedOtpLoader(true);
            }
            else {
                setVerifiedEmailOtpLoader(true);
            }
            SetAddFamilyMemeber(function (addFamilyMember) {
                var _a, _b, _c, _d, _e, _f;
                addFamilyMember.otp = otp;
                if (isMobile) {
                    addFamilyMember.otponsms = "1";
                    addFamilyMember.otponemail = "0";
                }
                else {
                    addFamilyMember.otponemail = "1";
                    addFamilyMember.otponsms = "0";
                }
                var callBackFunctionSuccess = function (familyAccount, isMobile) {
                    if (isMobile) {
                        setShowMobileOtp(false);
                    }
                    else {
                        setShowEmailOtp(false);
                    }
                    if ((familyAccount === null || familyAccount === void 0 ? void 0 : familyAccount.status) == "Verified" && isMobile == false) {
                        setVerifiedEmailOtp(true);
                        setVerifiedEmailOtpLoader(false);
                    }
                    if ((familyAccount === null || familyAccount === void 0 ? void 0 : familyAccount.status) == "Verified" && isMobile) {
                        setVerifiedOtpLoader(false);
                        setVerifiedMobileOtp(true);
                    }
                };
                var callBackFunctionError = function (isMobile) {
                    if (isMobile) {
                        setShowMobileOtp(false);
                    }
                    else {
                        setShowEmailOtp(false);
                    }
                    if (isMobile) {
                        setVerifiedOtpLoader(false);
                        setVerifiedMobileOtp(false);
                    }
                    else {
                        setVerifiedEmailOtpLoader(false);
                        setVerifiedEmailOtp(false);
                    }
                };
                console.log("Familydetails", props.selectedAddFamilyMember);
                props.selectedAddFamilyMember.smsFlag = "S";
                if (((_a = props === null || props === void 0 ? void 0 : props.selectedAddFamilyMember) === null || _a === void 0 ? void 0 : _a.familymemberdetails) != null &&
                    ((_b = props === null || props === void 0 ? void 0 : props.selectedAddFamilyMember) === null || _b === void 0 ? void 0 : _b.familymemberdetails) !== undefined &&
                    ((_d = (_c = props === null || props === void 0 ? void 0 : props.selectedAddFamilyMember) === null || _c === void 0 ? void 0 : _c.familymemberdetails) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                    var familyAccount = (_e = props.selectedAddFamilyMember.familymemberdetails) === null || _e === void 0 ? void 0 : _e.find(function (account) { return account.accode == addFamilyMember.accode; }), familyIndex = (_f = props.selectedAddFamilyMember.familymemberdetails) === null || _f === void 0 ? void 0 : _f.findIndex(function (account) { return account.accode == addFamilyMember.accode; });
                    familyAccount = addFamilyMember;
                    props.selectedAddFamilyMember.familymemberdetails[familyIndex] =
                        familyAccount;
                }
                else {
                    props.selectedAddFamilyMember.familymemberdetails.push(addFamilyMember);
                }
                var localObj = JSON.parse(JSON.stringify(props.selectedAddFamilyMember));
                localObj.familymemberdetails = [];
                localObj.familymemberdetails.push(addFamilyMember);
                di.clients.addFamilyMemDetails(localObj).then(function (resp) { return __awaiter(void 0, void 0, void 0, function () {
                    var _a, _b, _c, _d, _e, _f;
                    return __generator(this, function (_g) {
                        switch (_g.label) {
                            case 0:
                                console.log("response", resp);
                                if (!resp) return [3 /*break*/, 3];
                                if (!((resp === null || resp === void 0 ? void 0 : resp.message) != "" &&
                                    ((_b = (_a = resp === null || resp === void 0 ? void 0 : resp.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("please enter correct otp for")))) return [3 /*break*/, 1];
                                console.log("responseINSIDE", resp);
                                setError(__assign(__assign({}, error), { otp: isMobile
                                        ? "Invalid otp"
                                        : (error === null || error === void 0 ? void 0 : error.otp) !== "" && ((_c = error === null || error === void 0 ? void 0 : error.otp) === null || _c === void 0 ? void 0 : _c.length) > 0
                                            ? error === null || error === void 0 ? void 0 : error.otp
                                            : "", emailOtp: isMobile
                                        ? (error === null || error === void 0 ? void 0 : error.emailOtp) !== "" && ((_d = error === null || error === void 0 ? void 0 : error.emailOtp) === null || _d === void 0 ? void 0 : _d.length) > 0
                                            ? error === null || error === void 0 ? void 0 : error.otp
                                            : ""
                                        : "Invalid otp", isMobile: isMobile
                                        ? true
                                        : (error === null || error === void 0 ? void 0 : error.isMobile) !== null && (error === null || error === void 0 ? void 0 : error.isMobile)
                                            ? error === null || error === void 0 ? void 0 : error.isMobile
                                            : null, isEmail: isMobile
                                        ? (error === null || error === void 0 ? void 0 : error.isEmail) !== null && (error === null || error === void 0 ? void 0 : error.isEmail)
                                            ? error === null || error === void 0 ? void 0 : error.isEmail
                                            : null
                                        : true }));
                                isMobile
                                    ? setVerifiedOtpLoader(false)
                                    : setVerifiedEmailOtpLoader(false);
                                return [3 /*break*/, 3];
                            case 1:
                                setError(__assign(__assign({}, error), { otp: isMobile
                                        ? ""
                                        : (error === null || error === void 0 ? void 0 : error.otp) !== "" && ((_e = error === null || error === void 0 ? void 0 : error.otp) === null || _e === void 0 ? void 0 : _e.length) > 0
                                            ? error === null || error === void 0 ? void 0 : error.otp
                                            : "", isMobile: isMobile
                                        ? null
                                        : (error === null || error === void 0 ? void 0 : error.isMobile) !== null && (error === null || error === void 0 ? void 0 : error.isMobile)
                                            ? error === null || error === void 0 ? void 0 : error.isMobile
                                            : null, emailOtp: isMobile
                                        ? (error === null || error === void 0 ? void 0 : error.emailOtp) !== "" && ((_f = error === null || error === void 0 ? void 0 : error.emailOtp) === null || _f === void 0 ? void 0 : _f.length) > 0
                                            ? error === null || error === void 0 ? void 0 : error.otp
                                            : ""
                                        : "", isEmail: isMobile
                                        ? (error === null || error === void 0 ? void 0 : error.isEmail) !== null && (error === null || error === void 0 ? void 0 : error.isEmail)
                                            ? error === null || error === void 0 ? void 0 : error.isEmail
                                            : null
                                        : null }));
                                return [4 /*yield*/, (props === null || props === void 0 ? void 0 : props.getVerifiedFlags(addFamilyMember === null || addFamilyMember === void 0 ? void 0 : addFamilyMember.accode, callBackFunctionSuccess, callBackFunctionError, isMobile))];
                            case 2:
                                _g.sent();
                                _g.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); });
                return addFamilyMember;
            });
            return [2 /*return*/];
        });
    }); };
    var sendOtp = function (isMobile) {
        var _a, _b;
        isMobile ? setMobileOtpSentSuccess(false) : setEmailOtpSentSuccess(false);
        console.log(props.selectedAddFamilyMember);
        console.log(addFamilyMember);
        setError(__assign(__assign({}, error), { otp: isMobile
                ? ""
                : (error === null || error === void 0 ? void 0 : error.otp) !== "" && ((_a = error === null || error === void 0 ? void 0 : error.otp) === null || _a === void 0 ? void 0 : _a.length) > 0
                    ? error === null || error === void 0 ? void 0 : error.otp
                    : "", isMobile: isMobile
                ? null
                : (error === null || error === void 0 ? void 0 : error.isMobile) !== null && (error === null || error === void 0 ? void 0 : error.isMobile)
                    ? error === null || error === void 0 ? void 0 : error.isMobile
                    : null, emailOtp: isMobile
                ? (error === null || error === void 0 ? void 0 : error.emailOtp) !== "" && ((_b = error === null || error === void 0 ? void 0 : error.emailOtp) === null || _b === void 0 ? void 0 : _b.length) > 0
                    ? error === null || error === void 0 ? void 0 : error.otp
                    : ""
                : "", isEmail: isMobile
                ? (error === null || error === void 0 ? void 0 : error.isEmail) !== null && (error === null || error === void 0 ? void 0 : error.isEmail)
                    ? error === null || error === void 0 ? void 0 : error.isEmail
                    : null
                : null }));
        SetAddFamilyMemeber(function (addFamilyMember) {
            var _a, _b, _c, _d, _e, _f;
            console.log("inmethod", addFamilyMember);
            if (isMobile) {
                addFamilyMember.otponsms = "1";
                addFamilyMember.otponemail = "0";
            }
            else {
                addFamilyMember.otponsms = "0";
                addFamilyMember.otponemail = "1";
            }
            if (((_a = props === null || props === void 0 ? void 0 : props.selectedAddFamilyMember) === null || _a === void 0 ? void 0 : _a.familymemberdetails) != null &&
                ((_b = props === null || props === void 0 ? void 0 : props.selectedAddFamilyMember) === null || _b === void 0 ? void 0 : _b.familymemberdetails) !== undefined &&
                ((_d = (_c = props === null || props === void 0 ? void 0 : props.selectedAddFamilyMember) === null || _c === void 0 ? void 0 : _c.familymemberdetails) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                var familyAccount = (_e = props.selectedAddFamilyMember.familymemberdetails) === null || _e === void 0 ? void 0 : _e.find(function (account) { return account.accode == addFamilyMember.accode; }), familyIndex = (_f = props.selectedAddFamilyMember.familymemberdetails) === null || _f === void 0 ? void 0 : _f.findIndex(function (account) { return account.accode == addFamilyMember.accode; });
                familyAccount = addFamilyMember;
                familyAccount.otp = "";
                props.selectedAddFamilyMember.familymemberdetails[familyIndex] =
                    familyAccount;
            }
            else {
                props.selectedAddFamilyMember.familymemberdetails.push(addFamilyMember);
            }
            var localObj = JSON.parse(JSON.stringify(props.selectedAddFamilyMember));
            localObj.smsFlag = "O";
            localObj.familymemberdetails = [];
            localObj.familymemberdetails.push(addFamilyMember);
            di.clients
                .addFamilyMemDetails(localObj)
                .then(function (resp) {
                if (resp) {
                    //      props.setSuccessfulMsg(true), props.SetAddFamilyMemeber(false);
                    // props.getFamilyDetails();
                    setResentOtp(true);
                    isMobile
                        ? setMobileOtpSentSuccess(true)
                        : setEmailOtpSentSuccess(true);
                }
            })
                .catch(function (err) {
                setResentOtp(true);
                isMobile
                    ? setMobileOtpSentSuccess(false)
                    : setEmailOtpSentSuccess(false);
            });
            return addFamilyMember;
        });
    };
    var getSearchDetails = function (searchText) {
        setSearchLoader(true);
        var searchTagging = {
            searchValue: searchText,
            page: 1,
            pageSize: 100,
        };
        di.clients
            .getSearchFamilyTagging(searchTagging)
            .then(function (searchResp) {
            setSearchData(searchResp);
            setSearchLoader(false);
        })
            .catch(function (error) {
            setSearchData([]);
            setSearchLoader(false);
        });
    };
    var submitFamilyMember = function () {
        props === null || props === void 0 ? void 0 : props.setResetFamilyAddForm(false);
        SetAddFamilyMemeber(function (addFamilyMember) {
            //   props.selectedAddFamilyMember.familymemberdetails.push(addFamilyMember);
            //   props.selectedAddFamilyMember.smsFlag = "S";
            var localObj = JSON.parse(JSON.stringify(props.selectedAddFamilyMember));
            localObj.smsFlag = "S";
            localObj.familymemberdetails = [];
            localObj.familymemberdetails.push(addFamilyMember);
            di.clients.addFamilyMemDetails(localObj).then(function (resp) {
                if (resp) {
                    props.setSuccessfulMsg(true), props.SetAddFamilyMemeber(false);
                    props.setResetFamilyAddForm(true);
                    props.getFamilyDetails();
                }
            });
            return addFamilyMember;
        });
    };
    useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.resetFamilyAddForm) !== null &&
            (props === null || props === void 0 ? void 0 : props.resetFamilyAddForm) !== undefined &&
            (props === null || props === void 0 ? void 0 : props.resetFamilyAddForm)) {
            setShowMobileOtpSection(true);
            setShowEmailOtpSection(true);
            setVerifiedEmailOtp(false);
            setVerifiedEmailOtpLoader(false);
            setVerifiedOtpLoader(false);
            setVerifiedMobileOtp(false);
            setSearchData([]);
            SetAddFamilyMemeber({
                relation: null,
                accode: "",
                otp: "",
                otponsms: "1",
                otponemail: "",
            });
            setShowMobileOtp(false);
            setShowEmailOtp(false);
            setSelectedFamliyTaggingEntity(null);
        }
    }, [props === null || props === void 0 ? void 0 : props.resetFamilyAddForm]);
    return (React.createElement(Row, null,
        React.createElement(Col, { lg: 12, className: "leadpage-selectdropdown px-20 pt-20 pb-20 add-family" },
            React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey" },
                "Relation ",
                React.createElement("span", { className: "redstar" }, "*")),
            React.createElement(SelectDropdown, { placeholderClassName: "holder leadselect-holder", placeholder: "Select relation", id: "md_prodfeedback", name: "md_prodfeedback", selected: true, defaultValue: addFamilyMember === null || addFamilyMember === void 0 ? void 0 : addFamilyMember.relation, required: true, onChangeEvent: function (e) {
                    SetAddFamilyMemeber(__assign(__assign({}, addFamilyMember), { relation: e.target.value }));
                }, onBlur: function (error) {
                    if (error.required)
                        setError(function (error) {
                            return __assign(__assign({}, error), { relation: "This field is required" });
                        });
                    else
                        setError(function (error) {
                            error.relation = "";
                            return error;
                        });
                }, errorText: error.relation, dropdownOptions: props.masterRelation, downarrow: "edel-icon-arrow-down", className: "family-member-drp mgt-10" })),
        React.createElement(Col, { lg: 12, className: "mt-20 px-20" },
            React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey" },
                "Account Code ",
                React.createElement("span", { className: "redstar" }, "*")),
            React.createElement(InputField, { className: "mgt-10 RobotoM_16_500 txt_blackOne1 family-memeber-txt", placeholderClassName: "", defaultValue: addFamilyMember === null || addFamilyMember === void 0 ? void 0 : addFamilyMember.accode, required: true, onChangeEvent: function (e) {
                    if (e.target.value !== "") {
                        setOpenState(true);
                        getSearchDetails(e.target.value);
                        SetAddFamilyMemeber(__assign(__assign({}, addFamilyMember), { accode: e.target.value }));
                    }
                    else {
                        setSelectedFamliyTaggingEntity(null);
                        setShowMobileOtp(false);
                        setShowEmailOtp(false);
                    }
                }, onBlur: function (error) {
                    if (error.required)
                        setError(function (error) {
                            return __assign(__assign({}, error), { accode: "This field is required" });
                        });
                    else
                        setError(function (error) {
                            error.accode = "";
                            return error;
                        });
                }, errorText: error.accode }),
            openState && searchData.length > 0 && (React.createElement("div", { className: "position-absolute bg_white add-family-member" },
                React.createElement(Inputtablebottom, { clientSearchList: searchData, loader: searchLoader, clientSearchFlag: true, setCallbackFunction: function (data) {
                        setOpenState(false);
                        setResentOtp(false);
                        setSelectedFamliyTaggingEntity(data);
                        SetAddFamilyMemeber(__assign(__assign({}, addFamilyMember), { accode: data === null || data === void 0 ? void 0 : data.accountCode }));
                        //sendOtp(true);
                        // di.clients.setSelectedClientOnSearchClick(data);
                        // props?.setsearchText("");
                    }, errorText: ErrorText })))),
        selectedFamliyTaggingEntity &&
            addFamilyMember.accode &&
            addFamilyMember.relation && (React.createElement(React.Fragment, null,
            React.createElement(Col, { lg: 12, className: "mt-20 px-20" },
                React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey" }, "Name"),
                React.createElement("span", { className: "displayvalue-data" }, selectedFamliyTaggingEntity === null || selectedFamliyTaggingEntity === void 0 ? void 0 : selectedFamliyTaggingEntity.clientName)),
            React.createElement(Col, { lg: 12, className: "mt-20  px-20" },
                React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey" }, "Mobile"),
                React.createElement("span", { className: "displayvalue-data" }, selectedFamliyTaggingEntity === null || selectedFamliyTaggingEntity === void 0 ? void 0 :
                    selectedFamliyTaggingEntity.mobileNo,
                    showMobileOtpSection && !verifiedOtpLoader && (React.createElement("span", { className: "text-decoration-underline hand_cursor ps-2", onClick: function () {
                            // props.setverifyPopupMobile(true);
                            setShowMobileOtp(true);
                            sendOtp(true);
                            setShowMobileOtpSection(false);
                            //props.SetAddFamilyMemeber(false);
                        } }, "Verify")),
                    verifiedOtpLoader && (React.createElement("div", { className: "loader-box pe-5" },
                        React.createElement("img", { src: loaderGIF }))),
                    showMobileOtp == false && verifiedMobileOtp && (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "txt_green displayFlex" },
                            React.createElement("i", { className: "edel-icon-success-group" }),
                            React.createElement("span", { className: "mgl-10 DMSansNormal_12_400" }, "Verified")))))),
            showMobileOtp && (React.createElement(Col, { lg: 12 },
                React.createElement(AddFamilyOtp, { resendOtp: resendOtp, isMobile: true, sendOtp: sendOtp, verifyOtp: verifyOtp, setResentOtp: setResentOtp, otpSentSuccess: error &&
                        ((_a = error === null || error === void 0 ? void 0 : error.otp) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        (error === null || error === void 0 ? void 0 : error.isMobile) !== null &&
                        (error === null || error === void 0 ? void 0 : error.isMobile)
                        ? false
                        : mobileOtpSentSuccess, otpmessage: error && (error === null || error === void 0 ? void 0 : error.otp) ? error === null || error === void 0 ? void 0 : error.otp : "", setOtpSentSuccess: setMobileOtpSentSuccess }))),
            React.createElement(Col, { lg: 12, className: "mt-20 px-20" },
                React.createElement("label", { className: "DMSanN_14_400 txt_primaryGrey" }, "Email"),
                React.createElement("span", { className: "displayvalue-data" }, selectedFamliyTaggingEntity === null || selectedFamliyTaggingEntity === void 0 ? void 0 :
                    selectedFamliyTaggingEntity.email,
                    showEmailOtpSection && !verifiedEmailOtpLoader && (React.createElement("span", { className: "DMSanN_14_400 text-decoration-underline hand_cursor ps-2", onClick: function () {
                            //  props.setverifyPopupEmail(true);
                            setShowEmailOtp(true);
                            sendOtp(false);
                            setShowEmailOtpSection(false);
                            // props.SetAddFamilyMemeber(false);
                        } }, "Verify")),
                    verifiedEmailOtpLoader && (React.createElement("div", { className: "loader-box pe-5" },
                        React.createElement("img", { src: loaderGIF }))),
                    showEmailOtp == false && verifiedEmailOtp && (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "txt_green displayFlex" },
                            React.createElement("i", { className: "edel-icon-success-group" }),
                            React.createElement("span", { className: "mgl-10 DMSansNormal_12_400" }, "Verified")))))),
            showEmailOtp && (React.createElement(Col, { lg: 12 },
                React.createElement(AddFamilyOtp, { resendOtp: resendOtp, isMobile: false, sendOtp: sendOtp, verifyOtp: verifyOtp, setResentOtp: setResentOtp, otpSentSuccess: error &&
                        ((_b = error === null || error === void 0 ? void 0 : error.emailOtp) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                        (error === null || error === void 0 ? void 0 : error.isEmail) !== null &&
                        (error === null || error === void 0 ? void 0 : error.isEmail)
                        ? false
                        : emailOtpSentSuccess, otpmessage: error && (error === null || error === void 0 ? void 0 : error.emailOtp) ? error === null || error === void 0 ? void 0 : error.emailOtp : "", setOtpSentSuccess: setEmailOtpSentSuccess }))))),
        React.createElement(Col, { lg: 12, className: "mt-20 px-20 pb-4" },
            React.createElement(EdButton, { btnTyp: "midnight-blue", className: "w-100", disabled: !((addFamilyMember === null || addFamilyMember === void 0 ? void 0 : addFamilyMember.relation) && (addFamilyMember === null || addFamilyMember === void 0 ? void 0 : addFamilyMember.accode)) ||
                    (error && (error === null || error === void 0 ? void 0 : error.otp) !== "" && ((_c = error === null || error === void 0 ? void 0 : error.otp) === null || _c === void 0 ? void 0 : _c.length) > 0) ||
                    (error && (error === null || error === void 0 ? void 0 : error.emailOtp) !== "" && ((_d = error === null || error === void 0 ? void 0 : error.emailOtp) === null || _d === void 0 ? void 0 : _d.length) > 0), value: "Submit", onClick: function () {
                    submitFamilyMember();
                } }))));
};
export default AddFamilyMember;
